.terminal {
    font-family: 'courier new', monospace;
    color: green;
}
